import _ from 'lodash';
import React from 'react';

import { InstrumentGroup as InstrumentGroupNode } from 'types/drupal/InstrumentGroupNode';

import InstrumentGroupItem from 'components/pages/default/InstrumentGroupItem';

interface Props {
    instrumentGroup: InstrumentGroupNode;
    isMobile: boolean;
}

class InstrumentGroup extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    public render() {
        const showPrice = _.get(this.props.instrumentGroup, 'show_price.value') || false;
        return (
            <div className="row">
                { this.props.instrumentGroup.instrument_refs.map((groupItem, i) => {
                    return (
                                <InstrumentGroupItem
                                    instrumentGroupItem={groupItem}
                                    showPrice={showPrice}
                                    key={i}
                                    isMobile={this.props.isMobile}
                                />
                    );
                })
                }
        </div>
        );
    }
}

export default InstrumentGroup;



// WEBPACK FOOTER //
// ./src/components/pages/default/InstrumentGroup.tsx